import React from 'react';
import { format } from 'date-fns';
import { FiCalendar, FiClock } from 'react-icons/fi';

import { isValidDate } from '../../../utils/utils';
import FilesPreview from '../../FilesPreview/FilesPreview';
import styles from '../congressView.module.scss';

export default function Infos({ congress }) {
  const startDate = isValidDate(congress?.startDate) && new Date(congress.startDate);
  const endDate = isValidDate(congress?.endDate) && new Date(congress.endDate);
  const startTime = startDate
    && `${String(startDate.getHours()).padStart(2, '0')}:${String(startDate.getMinutes()).padStart(2, '0')}`;
  const endTime = endDate
    && `${String(endDate.getHours()).padStart(2, '0')}:${String(endDate.getMinutes()).padStart(2, '0')}`;

  return (
    <div className={styles.panel}>
      <div className={styles.box}>
        <h3>Informations générales</h3>
        <h1>{congress?.name}</h1>
        <div className={styles.dates}>
          {startDate && (
            <div className={styles.date}>
              <FiCalendar size={18} />
              <span className={styles.dateLabel}>Début</span>
              <strong>{format(startDate, 'dd/MM/yyyy')}</strong>
              <FiClock size={18} />
              <span>{startTime}</span>
            </div>
          )}
          {endDate && (
            <div className={styles.date}>
              <FiCalendar size={18} />
              <span className={styles.dateLabel}>Fin</span>
              <strong>{format(endDate, 'dd/MM/yyyy')}</strong>
              <FiClock size={18} />
              <span>{endTime}</span>
            </div>
          )}
        </div>
        {congress?.description && (
          <>
            <label>Description</label>
            <p>{congress.description}</p>
          </>
        )}
        <label>Lieu</label>
        <p>
          {[congress?.location, congress?.city].filter(Boolean).join(' - ') || '—'}
        </p>
        {congress?.url && (
          <a href={congress.url} target="_blank" rel="noreferrer" className={styles.link}>
            {congress.url}
          </a>
        )}
        {congress?.cover && <FilesPreview files={[congress.cover]} name="cover" />}
      </div>

      {(congress?.drugs?.length > 0 || congress?.therapeuticAreas?.length > 0) && (
        <div className={styles.box}>
          <h3>Produits</h3>
          {congress?.drugs?.length > 0 && (
            <>
              <label>Produits</label>
              <div className={styles.tags}>
                {congress.drugs.map((d) => <span key={d._id}>{d.name}</span>)}
              </div>
            </>
          )}
          {congress?.therapeuticAreas?.length > 0 && (
            <>
              <label>Aires thérapeutiques</label>
              <div className={styles.tags}>
                {congress.therapeuticAreas.map((d) => <span key={d._id}>{d.name}</span>)}
              </div>
            </>
          )}
        </div>
      )}

      {congress?.rational && (
        <div className={styles.box}>
          <h3>Rationnel de participation</h3>
          <p>{congress.rational}</p>
        </div>
      )}

      {congress?.dmos && (
        <div className={styles.box}>
          <h3>Instructions LEA / Transparence / Remboursement</h3>
          <p>{congress.dmos}</p>
        </div>
      )}

      {congress?.roadbooks?.length > 0 && (
        <div className={styles.box}>
          <h3>Road book</h3>
          <FilesPreview files={congress.roadbooks} name="roadbook" />
        </div>
      )}

      {congress?.reports?.length > 0 && (
        <div className={styles.box}>
          <h3>Compte rendu</h3>
          <FilesPreview files={congress.reports} name="reports" />
        </div>
      )}
    </div>
  );
}
